// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-action-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: #ffffff;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 0 2.4rem;
  z-index: 100;
}

/* Offset sidebar on desktop */
@media (min-width: 768px) {
  .bottom-action-bar {
    left: var(--sidebar-width, 220px);
  }
}

.bottom-action-bar__btn-dark {
  background-color: #374151;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 0 1.6rem;
  height: 40px;
  font-size: 1.3rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.15s;
  white-space: nowrap;
}

.bottom-action-bar__btn-dark:hover {
  background-color: #1f2937;
}

.bottom-action-bar__btn-dark:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bottom-action-bar__btn-primary {
  background-color: #f97316;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 0 1.6rem;
  height: 40px;
  font-size: 1.3rem;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.15s;
  white-space: nowrap;
}

.bottom-action-bar__btn-primary:hover:not(:disabled) {
  background-color: #ea6c00;
}

.bottom-action-bar__btn-primary:disabled {
  background-color: #fdba74;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DetailCandidature/BottomActionBar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":[".bottom-action-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background-color: #ffffff;\n  border-top: 1px solid #e5e7eb;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding: 0 2.4rem;\n  z-index: 100;\n}\n\n/* Offset sidebar on desktop */\n@media (min-width: 768px) {\n  .bottom-action-bar {\n    left: var(--sidebar-width, 220px);\n  }\n}\n\n.bottom-action-bar__btn-dark {\n  background-color: #374151;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  padding: 0 1.6rem;\n  height: 40px;\n  font-size: 1.3rem;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.15s;\n  white-space: nowrap;\n}\n\n.bottom-action-bar__btn-dark:hover {\n  background-color: #1f2937;\n}\n\n.bottom-action-bar__btn-dark:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.bottom-action-bar__btn-primary {\n  background-color: #f97316;\n  color: #ffffff;\n  border: none;\n  border-radius: 6px;\n  padding: 0 1.6rem;\n  height: 40px;\n  font-size: 1.3rem;\n  cursor: pointer;\n  font-weight: 600;\n  transition: background-color 0.15s;\n  white-space: nowrap;\n}\n\n.bottom-action-bar__btn-primary:hover:not(:disabled) {\n  background-color: #ea6c00;\n}\n\n.bottom-action-bar__btn-primary:disabled {\n  background-color: #fdba74;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
